import React from 'react';
import PropTypes from 'prop-types';

function cell({ cell: { value: initialValue } }) {
  return <div style={{ fontWeight: 'bold', padding: '10px 0' }}>{initialValue}</div>;
}

cell.propTypes = {
  cell: PropTypes.object,
};

export default cell;
